import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/isairurl/`;

const addUrl = async (url) => {
  const response = await axios.post(API_URL, { url }, { withCredentials: true });
  return response.data;
};

const getList = async (page = 1, limit = 50) => {
  const response = await axios.get(API_URL, {
    params: { page, limit },
    withCredentials: true
  });
  return response.data;
};

const checkByUrl = async (url) => {
  const response = await axios.get(`${API_URL}check`, {
    params: { url },
    withCredentials: true
  });
  return response.data;
};

const deleteUrl = async (id) => {
  await axios.delete(`${API_URL}${id}`, { withCredentials: true });
};

export default {
  addUrl,
  getList,
  checkByUrl,
  deleteUrl
};
